angular.module('rjmNg.constants')
.constant('dataWarehouse',

  VIEW: Object.freeze
    CHOOSE_TABLE: 0
    COLUMNS: 1
    DATA: 2

  RECHECK_TYPE: Object.freeze
    NEVER: 'never'
    ALWAYS: 'always'
    DAILY: 'daily'
    WEEKLY: 'weekly'
    MONTHLY: 'monthly'
    ONCE: 'once'

  RECHECK_DOC_URL: 'https://docs.magento.com/mbi/data-analyst/data-warehouse-mgr/cfg-data-rechecks.html'

  REPLICATION_METHOD_DOC_URL: 'https://docs.magento.com/mbi/data-analyst/data-warehouse-mgr/cfg-replication-methods.html'

  REPLICATION_METHOD: Object.freeze
    NONE: 'none'
    SINGLE_AUTO_INC_PK: 'single_auto_increment_pk'
    ADD_DATE: 'date'
    FULL_TABLE: 'all'
    UNIX_TS: 'unix_timestamp'
    PK_BATCH: 'pk_batch'
    MONGO_ID: 'mongo'
    USERPUSH: 'userpush'
    MONGO_BATCH: 'mongo_batch'
    MONGO_SUBTABLE: 'mongo_subtable'
    MODIFIED_AT: 'modified_at'
    MONGO_MODIFIED_AT: 'mongo_modified_at'
    REDSHIFT_UNLOAD: 'redshift_unload'
    INCREMENTAL_REDSHIFT_UNLOAD: 'incremental_redshift_unload'

  REPLICATION_NAMES: Object.freeze
    none: 'Paused'
    single_auto_increment_pk: 'Single Auto Incrementing Primary Key'
    date: 'Add Date'
    all: 'Full Table'
    unix_timestamp: 'Unix Timestamp'
    pk_batch: 'Primary Key Batch Monitoring'
    mongo: 'Single Primary Key'
    userpush: 'File Upload'
    mongo_batch: 'Primary Key Batch Monitoring'
    mongo_subtable: 'Mongo Subtable'
    modified_at: 'Modified At'
    mongo_modified_at: 'Modified At'
    redshift_unload: 'Redshift Unload'
    incremental_redshift_unload: 'Incremental Redshift Unload'

  REPLICATION_INCREMENTAL: [
    'none'
    'single_auto_increment_pk'
    'date'
    'mongo'
    'mongo_batch'
    'modified_at'
    'mongo_modified_at'
    'unix_timestamp',
    'incremental_redshift_unload'
  ]

  REPLICATION_FULL: [
    'none'
    'all'
    'pk_batch'
    'mongo_batch'
    'redshift_unload'
  ]

  FIELD_TYPES:
    VALUE_CURRENCY:
      id: 'value_currency'
      name: 'Currency'
      active: true
    VALUE_GENERAL:
      id: 'value_general'
      name: 'Number'
      active: true
    VALUE_SECONDS:
      id: 'value_seconds'
      name: 'Time (seconds)'
      active: true
    VALUE_PERCENTAGE:
      id: 'value_percentage'
      name: 'Percent'
      active: true
    DATETIME:
      id: 'datetime'
      name: 'Datetime'
      active: true
    FLAG:
      id: 'flag'
      name: 'Short Text'
      active: true
    DESCRIPTION:
      id: 'description'
      name: 'Long Text'
      active: true
    IP:
      id: 'ip'
      name: 'IP'
      active: false
    EMAIL:
      id: 'email'
      name: 'Email'
      active: false
    US_POSTAL_CODE:
      id: 'us_postal_code'
      name: 'Postal Code (US)'
      active: false
    URL:
      id: 'url'
      name: 'URL'
      active: false
    VALUE_BYTES:
      id: 'value_bytes'
      name: 'Value (bytes)'
      active: false

  DATA_TYPES:
    DATETIME:
      id: 'DATETIME'
      name: 'Datetime'
    DECIMAL_10_2:
      id: 'DECIMAL(10,2)'
      name : 'Decimal'
    VARCHAR_255:
      id: 'VARCHAR(255)'
      name: 'String'
    BIGINT:
      id:'BIGINT'
      name: 'Integer'
)
